import React, { useId, useState } from 'react';

// Native SVG compositing keeps the existing artwork intact. Each foreground
// cutout moves separately over an inpainted, empty laptop/background plate.
const layers = [
  {
    name: 'card',
    path: 'M592 334 L667 350 Q728 369 750 312 L1139 425 Q1166 433 1153 472 L1020 766 Q1011 791 981 779 L492 609 Q465 601 476 572 Z',
  },
  {
    name: 'chatgpt',
    path: 'M402 164 L504 185 Q538 192 538 233 L530 321 Q528 359 494 358 L393 347 Q352 343 355 300 L361 205 Q363 172 402 164 Z',
  },
  {
    name: 'gemini',
    path: 'M614 165 L703 178 Q745 181 744 226 L739 313 Q737 355 704 355 L607 342 Q566 338 566 299 L571 205 Q574 174 614 165 Z',
  },
  {
    name: 'code',
    path: 'M250 523 L359 522 Q402 520 402 565 L407 664 Q409 704 367 710 L249 714 Q208 714 206 672 L202 575 Q200 538 250 523 Z',
  },
  {
    name: 'subscriptions',
    path: 'M1183 626 L1293 636 Q1329 640 1325 682 L1303 800 Q1296 842 1256 839 L1146 821 Q1108 815 1117 773 L1135 670 Q1141 631 1183 626 Z',
  },
] as const;

export const SubscriptionMotion: React.FC = () => {
  const id = useId().replace(/:/g, '');
  const [ready, setReady] = useState(false);
  return (
    <div className="subscription-motion" aria-hidden="true" data-ready={ready}>
      <img
        className="subscription-motion-plate"
        src="/images/crypto-subscriptions-motion-plate-1200.webp"
        alt=""
        width="1536"
        height="1024"
        loading="lazy"
        decoding="async"
        onLoad={() => setReady(true)}
        onError={() => setReady(false)}
      />
      <svg viewBox="0 0 1536 1024" focusable="false">
        <defs>
          {layers.map((layer) => (
            <clipPath key={layer.name} id={`${id}-${layer.name}`}>
              <path d={layer.path} />
            </clipPath>
          ))}
        </defs>
        {layers.map((layer) => (
          <g key={layer.name} className={`subscription-layer subscription-layer-${layer.name}`}>
            <g clipPath={`url(#${id}-${layer.name})`}>
              <image href="/images/crypto-subscriptions-v3-1200.webp" width="1536" height="1024" />
            </g>
          </g>
        ))}
      </svg>
    </div>
  );
};
